module.exports = __webpack_public_path__ + "media/images/arrow-right-c938fd2e19408496abeb51e6ccf8d585.svg";